import { render, staticRenderFns } from "./gj-rate.vue?vue&type=template&id=1f400b97&scoped=true&"
import script from "./gj-rate.vue?vue&type=script&lang=js&"
export * from "./gj-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f400b97",
  null
  
)

export default component.exports